module.exports = "https://cdn2-fs.clearscore.com/flux/images/6f6cf91fecea6dea500493a65452a412.jpg";